import api from './api';
import type { User } from '../types/user';

/**
 * Service to fetch all users with the 'mentor' role (Admin only).
 */
export const getAllMentors = async (): Promise<User[]> => {
  try {
    const response = await api.get<User[]>('/mentor/users/role/mentor');
    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to fetch mentors.');
  }
};

// ✨ NEW: Define a specific type for the create mentor payload
interface CreateMentorPayload {
    name: string;
    email: string;
    password: string;
}

/**
 * Service to create a new mentor account (Admin only).
 * @param payload - The new mentor's details (name, email, password).
 */
// ✅ FIX: Use the new payload type
export const createMentor = async (payload: CreateMentorPayload): Promise<{ message: string; mentor: User }> => {
  try {
    const response = await api.post<{ message: string; mentor: User }>('/mentor/create', payload);
    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to create mentor account.');
  }
};

/**
 * Service to update a user's status (Admin only).
 */
export const updateUserStatus = async (userId: string, status: 'active' | 'suspended'): Promise<User> => {
  try {
    const response = await api.patch<User>(`/mentor/users/${userId}/status`, { status });
    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to update user status.');
  }
};

/**
 * Service to permanently delete a user account (Admin only).
 */
export const deleteUserAccount = async (userId: string): Promise<string> => {
  try {
    const response = await api.delete<{ message: string }>(`/mentor/users/${userId}`);
    return response.data.message;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to delete user account.');
  }
};




const adminService = {
    getAllMentors,
    createMentor,
    updateUserStatus,
    deleteUserAccount,
};

export default adminService;